import React, { useState, useEffect } from "react";

export default ({ activeFilters = [], setActiveFilters = (_ = []) => { }, filters = [] }) => {
    const [selectedFilter, setSelectedFilter] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        if (selectedFilter) {
            setActiveFilters([selectedFilter]);
        } else {
            setActiveFilters([]);
        }
    }, [selectedFilter, setActiveFilters]);

    const handleFilterChange = (e) => {
        setSelectedFilter(e.target.value);
        setDropdownOpen(false);
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    return (
        <div>
            <select
                value={selectedFilter}
                onChange={handleFilterChange}
                onClick={toggleDropdown}
                onBlur={() => setDropdownOpen(false)}
                className="tw-text-[18px] tw-fafafa tw-font-sans tw-font-light tw-text-text tw-w-full tw-py-2"
            >
                {!dropdownOpen && (
                    <option value={selectedFilter} hidden={!selectedFilter}>
                        {selectedFilter ? `Content Type: ${filters.find(filter => filter.value === selectedFilter).display}` : 'Select a filter'}
                    </option>
                )}
                {dropdownOpen && (
                    <>
                        <option value="" hidden>Filter by...</option>
                        <option value="">All</option>
                        {filters.map((filter) => (
                            <option key={filter.value} value={filter.value}>
                                {filter.display}
                            </option>
                        ))}
                    </>
                )}
            </select>
        </div>
    );
};